let zendeskInstance: HTMLElement | null = null;
const scriptId = 'ze-snippet';

const waitForZendeskWindowObject = (callback: () => void) => {
  let attempts = 0;
  const maxAttempts = 10;
  const intervalTime = 500;
  const interval = setInterval(() => {
    if (window.zE) {
      callback();
      clearInterval(interval);
    } else {
      attempts++;

      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }
  }, intervalTime);
};

export const zendeskService: {
  init: (user: any) => void;
  onLoad: (
    callback: () => void,
    maxAttempts?: number,
    intervalTime?: number,
  ) => void;
  identify: (user: any) => void;
  open: () => void;
} = {
  init: (user): void => {
    if (!zendeskInstance && user) {
      if (user.tier_level === 30 || user.tier_level === 20) {
        var script = document.createElement('script');

        script.src =
          'https://static.zdassets.com/ekr/snippet.js?key=d89ce25e-79bf-4b0d-95f2-2ffafa2dfdfe';
        script.id = scriptId;
        window.zESettings = {
          webWidget: {
            position: { horizontal: 'right', vertical: 'bottom' },
            offset: { horizontal: '50px', vertical: '0px' },
            zIndex: 11,
          },
        };
        document.body.appendChild(script);
        zendeskInstance = script;

        function handleClickOutside(event: MouseEvent) {
          var chatWindow = document.getElementById('webWidget');

          if (chatWindow && !chatWindow.contains(event.target as Node)) {
            if (window.zE) {
              window.zE('webWidget', 'close');
            }
          }
        }

        document.addEventListener('click', handleClickOutside);
      }
    }
  },
  onLoad: (callback: () => void) => {
    waitForZendeskWindowObject(callback);
  },
  identify: (user) => {
    if (user.displayName && user.email) {
      zendeskService.onLoad(() => {
        if (window.zE) {
          window.zE('webWidget', 'identify', {
            name: user.displayName,
            email: user.email,
          });
        }
      });
    }
  },
  open: () => {
    const openWidget = () => {
      window.zE?.('webWidget', 'open');
    };

    if (window.zE) {
      // Defer to the next tick so the click that triggered this open isn't
      // also caught by the global click-outside handler (registered in init),
      // which would immediately close the widget on the same click.
      setTimeout(openWidget, 0);

      return;
    }

    zendeskService.onLoad(openWidget);
  },
};
